var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CartInfoCard',{attrs:{"infoValue":_vm.value,"text":_vm.text,"hideEdit":true,"icon":"/img_layout/calendar.svg","editable":_vm.editable,"small":_vm.small,"isShopopop":_vm.isShopopop},on:{"edit":_vm.edit}})
}
var staticRenderFns = []

export { render, staticRenderFns }